import { graphql } from 'gatsby'

// eslint-disable-next-line no-restricted-exports
export { default } from './Topic'

export const query = graphql`
  query ($slug: String!) {
    ghostTag(slug: { eq: $slug }) {
      ...GhostTagFields
    }
    allGhostPost(filter: { tags: { elemMatch: { slug: { eq: $slug } } } }) {
      nodes {
        ...GhostPostFields
      }
    }
  }
`
